const LADDER = [320, 640, 960, 1280, 1920, 2560];

const isManaged = (url) => typeof url === "string" && url.startsWith("/api/media/");

/** Request a right-sized variant of a media-library image. */
export function mediaSrc(url, width) {
  if (!isManaged(url) || !width) return url;
  return `${url}?w=${width}`;
}

/** Build a srcSet across our cached width ladder, capped at the layout need. */
export function mediaSrcSet(url, maxWidth) {
  if (!isManaged(url)) return undefined;
  const widths = LADDER.filter((w) => w <= maxWidth * 2);
  if (!widths.includes(LADDER.find((w) => w >= maxWidth))) {
    const next = LADDER.find((w) => w >= maxWidth);
    if (next) widths.push(next);
  }
  if (!widths.length) return undefined;
  return widths.map((w) => `${url}?w=${w} ${w}w`).join(", ");
}

export { LADDER as MEDIA_WIDTHS };

const TINY = 32;

/**
 * A sub-1KB preview of the real photo, upscaled by the browser so it reads as a soft blur
 * until the full image arrives. Managed media uses our variant ladder; Unsplash can resize
 * on its own CDN. Anything else gets no placeholder.
 */
export function placeholderSrc(url) {
  if (typeof url !== "string" || !url) return null;
  if (isManaged(url)) return `${url}?w=${TINY}`;
  if (url.includes("images.unsplash.com")) {
    const [base, query = ""] = url.split("?");
    const params = new URLSearchParams(query);
    params.set("w", String(TINY));
    params.set("q", "40");
    params.delete("h");
    return `${base}?${params.toString()}`;
  }
  return null;
}
